(() => {
let readMoreProduct = document.querySelector('.js-product__read-more');
let readLessProduct = document.querySelector('.js-product__read-less');
let productDescription = document.querySelector('.js-product__description');

if(readMoreProduct && productDescription){
 readMoreProduct.addEventListener("click", function (e) {
   productDescription.classList.add('product__description--show');
   readMoreProduct.classList.add('product__read-more--hide');
 });
}


if(readLessProduct && productDescription){
 readLessProduct.addEventListener("click", function (e) {
   productDescription.classList.remove('product__description--show');
   readLessProduct.classList.add('product__less-more--hide');
   readMoreProduct.classList.remove('product__read-more--hide');
 });
}
})();
